import {
    GET_INSTITUTIONS_LIST,
    GET_INSTITUTIONS_LIST_ERROR,
    GET_INSTITUTIONS_LIST_SUCCESS,
    SET_IPEDS_TAB,
} from './types'

const initialState = {
    ipedsTab: {
        facultyID: 0,
        primaryContactType: 0,
        tenureClassification: 0,
        primaryFunction: 0
    },
    institutionLookup: {
        isLoading: false,
        institutionList: []
    }
};

const ipedsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_IPEDS_TAB:
            return {
                ...state,
                ipedsTab: payload
            };
        case GET_INSTITUTIONS_LIST:
            return {
                ...state,
                institutionLookup: {
                    ...state.institutionLookup,
                    isLoading: true
                }
            };
        case GET_INSTITUTIONS_LIST_SUCCESS:
            return {
                ...state,
                institutionLookup: {
                    ...state.institutionLookup,
                    isLoading: false,
                    institutionList: payload
                }
            };
        case GET_INSTITUTIONS_LIST_ERROR:
            return {
                ...state,
                institutionLookup: {
                    ...state.institutionLookup,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};

export default ipedsReducer;